import {
  AVAILABLE_BRAND_FEATURES,
  ReschedulableBooking,
  ReschedulableStatus,
} from '@kouto/types';
import { useAppState, useDispatch } from 'AppProvider';
import useBrandToggleFeature from 'components/BrandToggleFeature/use-brand-toggle-feature';
import {
  GuestRescheduleState,
  resetRescheduleState,
  setCartData,
  setSelectedBookingId,
  setBookings,
  setSelectedRescheduleDate,
  setSelectedCalendarDate,
  setSelectedResourceId,
  setIsLoading,
} from 'reducers/guestReschedule';

const useGuestReschedule = () => {
  const dispatch = useDispatch();

  const state = useAppState((state: Record<string, unknown>) => state)
    .guestReschedule as GuestRescheduleState;

  const isRescheduleFlagEnabled = useBrandToggleFeature(
    AVAILABLE_BRAND_FEATURES.ENABLE_RESCHEDULE_BOOKINGS,
  );

  const bookingSelected = state?.bookings?.find(
    ({ bookingId }) => bookingId === state?.selectedBookingId,
  );

  const canReschedule =
    isRescheduleFlagEnabled &&
    bookingSelected?.status === ReschedulableStatus.ALLOWED;

  return {
    ...(state || {}),
    bookings: state?.bookings || [],
    bookingSelected,
    canReschedule,
    isLoading: state?.isLoading || false,
    setCartData: (data: { cartId: string; token: string }) =>
      dispatch(setCartData(data)),
    setBookings: (bookings: ReschedulableBooking[]) =>
      dispatch(setBookings(bookings)),
    setSelectedBookingId: (id: string) => dispatch(setSelectedBookingId(id)),
    setSelectedRescheduleDate: (date: string) =>
      dispatch(setSelectedRescheduleDate(date)),
    setSelectedCalendarDate: (date: string) =>
      dispatch(setSelectedCalendarDate(date)),
    setSelectedResourceId: (id: string) => dispatch(setSelectedResourceId(id)),
    setIsLoading: (isLoading: boolean) => dispatch(setIsLoading(isLoading)),
    resetRescheduleState: () => dispatch(resetRescheduleState()),
  };
};

export default useGuestReschedule;
